import { BackdropTheme, SternumTheme } from '@sternum/ui';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function SBOMLightBackdropTheme(theme: SternumTheme): Partial<BackdropTheme.BackdropTheme> {
  return {
    backdropFilterHide: '',
    backdropFilterShow: '',
    backgroundShow: 'rgba(36, 36, 36, 0.3)',
  };
}
